import { certifications } from './certificationsData';

export const Certifications = () => {
  return (
    <section id="certifications" className="section">
      <div className="section-head reveal">
        <div>
          <p className="section-eyebrow">04 — Certifications</p>
          <h2 className="section-title">Verified, not decorative</h2>
        </div>
      </div>
      <div className="cert-grid">
        {certifications.map((cert) => (
          <div className="cert-card reveal" key={cert.title}>
            <div className="cert-card-image">
              {cert.imageUrl ? (
                <img src={cert.imageUrl} alt={cert.title} />
              ) : (
                <div className="cert-card-image-placeholder">Add image</div>
              )}
            </div>
            <h3 className="cert-card-title">{cert.title}</h3>
            <p className="cert-card-issuer">
              {cert.issuer || 'Issuing organization TBD'}
              {cert.dateEarned ? ` · ${cert.dateEarned}` : ''}
            </p>
            {cert.verifyUrl ? (
              <a
                className="cert-card-link"
                href={cert.verifyUrl}
                target="_blank"
                rel="noreferrer"
              >
                Verify credential →
              </a>
            ) : (
              <span className="cert-card-link cert-card-link-disabled">
                Verification link TBD
              </span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
